import { HttpResponse, PaymentError } from '@/interfaces';
import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';

class ErrorHandlerService {
	constructor(private client: AxiosInstance) {}

	async getErrors(): Promise<HttpResponse<PaymentError[]>> {
		return this.client.get(`/error-handler`);
	}
}

export const errorHandlerService = new ErrorHandlerService(axiosClient);
